import React, { useEffect, useState } from "react";
import Image1 from "../../assets/office1.jpg";
import Image2 from "../../assets/bahirdar-view.webp";
import Image3 from "../../assets/photo_2026-03-28_11-26-06.jpg";
import Image4 from "../../assets/office2.jpg";
const slides = [
  { image: Image1 },
  { image: Image2 },
  { image: Image3 },
  { image: Image4 },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const i = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(i);
  }, []);

  return (
    <section className="relative w-full min-h-[85vh] lg:h-screen overflow-hidden text-white">
      {/* Background */}
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt="home background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#0b1d3a]/85"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 h-full flex items-center py-12 lg:py-0">
        <div className="w-full grid lg:grid-cols-2 gap-10 items-center">
          {/* LEFT */}
          <div className="text-left">
            <p className="text-[10px] tracking-[0.25em] text-yellow-400 mb-3">
              ETHIOPIA'S PREMIER LAW FIRM
            </p>

            <h1
              className="
              font-serif
              text-[28px] 
              sm:text-[34px] 
              md:text-[42px] 
              lg:text-[58px] 
              leading-tight 
              font-light 
              mb-4
            "
            >
              Advancing{" "}
              <span className="text-yellow-400 font-medium">Justice</span>,
              <br />
              Business & Society <br className="hidden sm:block" />
              Through Law
            </h1>

            <p
              className="
              text-[11px] 
              sm:text-xs 
              text-gray-300 
              leading-relaxed 
              max-w-md 
              mb-4 
              uppercase
            "
            >
              Serving both local and international clients, we aim to deliver
              practical solutions while fully complying with Ethiopian law.
            </p>

            <p
              className="
              italic text-gray-400 
              text-[11px] sm:text-xs 
              mb-5 border-l-2 
              border-yellow-400 pl-3
            "
            >
              "Personalized Solutions with Personal Attention"
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <button className="w-full sm:w-auto bg-yellow-500 text-black px-5 py-3 text-[11px] sm:text-sm font-medium tracking-wide">
                <a href="/appointment">SCHEDULE CONSULTATION →</a>
              </button>

              <button className="w-full sm:w-auto border border-white/30 px-5 py-3 text-[11px] sm:text-sm">
                <a href="/about-us">DISCOVER OUR LEGACY </a>
              </button>
            </div>
          </div>

          {/* RIGHT (GOES BELOW ON MOBILE) */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4 mt-8 lg:mt-0">
            {[
              { number: "28+", label: "YEARS COMBINED EXPERIENCE" },
              { number: "5", label: "DISTINGUISHED FORMER JUDGES" },
              { number: "24/7", label: "CLIENT SUPPORT" },
              { number: "07+", label: "PRACTICE AREAS" },
            ].map((item, i) => (
              <div
                key={i}
                className="
                  bg-white/5 border border-white/10 
                  backdrop-blur-md 
                  p-4 sm:p-6 
                  text-center
                "
              >
                <h3 className="text-2xl sm:text-4xl text-yellow-400 font-bold font-serif">
                  {item.number}
                </h3>
                <p className="text-[9px] sm:text-xs tracking-widest text-gray-300 mt-1 font-serif">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rotate-45 ${
              current === i ? "bg-yellow-400" : "border border-white"
            }`}
          />
        ))}
      </div>

      {/* Arrow (hidden on mobile like real site) */}
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
        className="hidden lg:flex absolute right-6 top-1/2 -translate-y-1/2 border border-white/30 w-10 h-10 items-center justify-center"
      >
        →
      </button>
    </section>
  );
}
